export const selectVirtualConsult = (state) => state.virtualConsult;
export const selectLoadingQuestionnaires = (state) => state.virtualConsult.loadingQuestionnaires;
export const selectOutcomes = (state) => state.virtualConsult.outcomes;
export const selectLoadingSegments = (state) => state.virtualConsult.loadingSegments;
export const selectUserSegments = (state) => state.virtualConsult.segments;
export const selectVcbVariablesList = (state) => state.virtualConsult.vcbVariablesList;
